import React, { useState } from "react"
import Slider from "react-slick"
import {
  Box,
  Paper,
  IconButton,
  Typography,
  useMediaQuery,
} from "@mui/material"
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew"
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

// Custom Arrow Components
const NextArrow = ({ onClick }) => (
  <IconButton
    style={{
      position: "absolute",
      top: "50%",
      right: "-40px", // Adjust if necessary to prevent overlap
      zIndex: 1,
      backgroundColor: "#fff",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
      borderRadius: "50%",
      transform: "translateY(-50%)",
    }}
    onClick={onClick}
  >
    <ArrowForwardIosIcon />
  </IconButton>
)

const PrevArrow = ({ onClick }) => (
  <IconButton
    style={{
      position: "absolute",
      top: "50%",
      left: "-40px", // Adjust if necessary to prevent overlap
      zIndex: 1,
      backgroundColor: "#fff",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
      borderRadius: "50%",
      transform: "translateY(-50%)",
    }}
    onClick={onClick}
  >
    <ArrowBackIosNewIcon />
  </IconButton>
)

const Categories = ({ categories, onCategoryClick }) => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0].name)

  // Media query to detect if the screen width is less than 620px
  const isSmallScreen = useMediaQuery("(max-width:620px)")

  const handleCategoryClick = (category) => {
    setSelectedCategory(category)
    onCategoryClick(category)
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 2,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  }

  return (
    <Box mt={4} position="relative" style={{ padding: "15px 60px" }}>
      <Slider {...settings}>
        {categories.map((category, index) => (
          <div key={index}>
            <div
              style={{
                padding: "10px 10px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paper
                elevation={3}
                style={{
                  textAlign: "center",
                  padding: isSmallScreen ? "10px" : "20px", // Adjust padding based on screen size
                  borderRadius: "50%",
                  width: isSmallScreen ? "70px" : "100px", // Smaller width on small screens
                  height: isSmallScreen ? "70px" : "100px", // Smaller height on small screens
                  minWidth: isSmallScreen ? "70px" : "100px", // Ensure minWidth is smaller on small screens
                  minHeight: isSmallScreen ? "70px" : "100px", // Ensure minHeight is smaller on small screens
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor:
                    selectedCategory === category.name ? "#cccccc" : "#f0f0f0",
                  border:
                    selectedCategory === category.name
                      ? "2px solid #3f51b5"
                      : "none",
                  cursor: "pointer",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)", // Ensure shadow is visible
                }}
                onClick={() => handleCategoryClick(category.name)}
              >
                <IconButton>{category.icon}</IconButton>
                <Typography
                  variant="body2" // Smaller text for smaller screens
                  style={{
                    marginTop: "10px",
                    fontSize: isSmallScreen ? "12px" : "14px",
                  }}
                >
                  {category.name}
                </Typography>
              </Paper>
            </div>
          </div>
        ))}
      </Slider>
    </Box>
  )
}

export default Categories
